import { render } from "./Lesssecureaccess.vue?vue&type=template&id=2e816ec4"
import script from "./Lesssecureaccess.vue?vue&type=script&lang=js"
export * from "./Lesssecureaccess.vue?vue&type=script&lang=js"

import "./Lesssecureaccess.vue?vue&type=style&index=0&id=2e816ec4&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__